<template>
    <div id="pagination" class="paging" v-if="data && data.pagination">
        <ul class="pagination">
            <li><a @click="navigate(getPrevUrl())" v-show="getPrevUrl() !== null"><<</a></li>
            <li :class="{ 'active': page.selected }" v-for="page in pages">
                <a  @click="navigate(getUrl(page.id))">{{page.id}}</a>
            </li>
            <li><a  @click="navigate(getNextUrl())" v-show="getNextUrl() !== null">»</a></li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        name: 'Pagination',
        props: {
            data: {
                pagination: {
                    type: Object,
                },
                navigationMethod: {
                    type: Function,
                }
            }
        },
        data() {
            return {
                pagination: this.data == null ? {} : this.data.pagination,
                pages: [],
                current_page_id : 1,
            }
        },
        methods: {
            ...mapActions([
               'getInvoices',
            ]),
            setPages() {

                if(this.pagination && this.pagination.last_page > 1) {
                    this.pages = [];
                    let max_page = 10;
                    let first_page = 1;
                    let last_page = this.pagination.last_page;
                    let current_page = this.getCurrentPageID();
                    let pad = 4;

                    if (last_page > max_page) {
                        if (current_page > max_page) {
                            first_page = (current_page - pad) < 1 ? 1 : (current_page - pad);
                            last_page = current_page + pad;
                        } else {
                            first_page = 1;
                            last_page = max_page;
                        }
                    }

                    for (let i = first_page; i <= last_page; i++) {
                        this.pages.push({
                            id: i,
                            selected: this.isCurrentPage(i),
                        });
                    }
                }
                else {
                    this.pages = [];
                }
            },
            getPrevUrl() {
                return this.getUrl(this.getCurrentPageID() > 1 ? (this.getCurrentPageID() - 1) : null);
            },
            getUrl(pageID) {

                if(pageID !== null) {
                    this.current_page_id = pageID;

                    if(this.data.navigationMethod) {
                        return this.pagination.path + '?page=' + pageID;
                    } else {
                        return this.$route.path + '?page=' + pageID;
                    }
                }

                return null;
            },
            getNextUrl() {
                return this.getUrl((this.getCurrentPageID() + 1) <= (this.pagination && this.pagination.last_page ? this.pagination.last_page : 1) ? (this.getCurrentPageID() + 1) : null);
            },
            getCurrentPageID() {
                return parseInt(this.$route.query.page  ? this.$route.query.page : 1);
            },
            isCurrentPage(pageID) {
                let queryPageID = this.getCurrentPageID();

                if(queryPageID === undefined && pageID == 1) {
                    return true;
                } else if(pageID == queryPageID){
                    return true;
                } else {
                    return false;
                }
            },
            navigate(url) {
                if(this.data.navigationMethod) {
                    this.data.navigationMethod(this.current_page_id);
                    this.$router.push({
                        path: this.$route.path+'?page='+this.current_page_id,
                    });
                } else {
                    this.$router.push({
                        path: url,
                    });
                }
            }
        },
        mounted() {
            this.setPages();
        },
        watch: {
            data: {
                handler: function(newVal) {
                    this.pagination = newVal.pagination;
                    this.setPages();
                },
                deep: true,
            },

        }
    }
</script>

<style lang="scss">
    #pagination {
        position: relative;
        margin-top: 20px;

        .pagination {
            margin: 0;

            .active>a, .active>a:hover, li>a:hover {
                color: #fff;
                background: #007bff;
                border: 1px solid transparent;
                text-decoration: none;
            }

            li a {
                border-radius: 0 !important;
                margin-right: 8px;
                color: #7c7c7c;
                border: 1px solid #ddd;
                position: relative;
                float: left;
                padding: 6px 12px;
                cursor: pointer;
            }

            .page-numbers {
                border: 0;
                color: #7c7c7c;
                position: absolute;
                right: 0;
                top: 3px;
            }
        }
    }
</style>